import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/Button/Button";
import { HTMLParser } from "@components/HTMLParser/HTMLParser";
import { ReceiptIcon } from "@components/icons/common";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import { useProviderBillDetailizationQuery } from "@services/jointBillServices/queries";

interface IBillDetailizationModalProps extends IUseModalProps {
  billId: number;
  billDetailizationUrl: string;
}

export const BillDetailizationModal: React.FC<IBillDetailizationModalProps> = (
  props,
) => {
  const { billDetailizationUrl, billId, ...modalProps } = props;

  const modal = useModal(modalProps);
  const { t } = useTranslation();

  const { data: billDetailizationHtml } = useProviderBillDetailizationQuery(
    billId,
    billDetailizationUrl,
  );

  return (
    <Modal
      modal={modal}
      badgeProps={{ icon: ReceiptIcon, color: "grey" }}
      actionButtons={
        <div className="flex w-full justify-center">
          <Button variant="secondary" onClick={modal.close} className="w-60">
            {t("billDetailizationModal.buttons.close")}
          </Button>
        </div>
      }
      title={t("billDetailizationModal.title")}
      className="min-w-full lg:w-full xl:min-w-[80rem]"
    >
      <div className="overflow-auto py-5 md:flex-1">
        <div className="h-full min-w-[1158px] px-4">
          {billDetailizationHtml && <HTMLParser html={billDetailizationHtml} />}
        </div>
      </div>
    </Modal>
  );
};
